<template>
    <div>
        <div class="area_title_board">
            <div class="bx_title">
                <div class="board_tit">
                    <h2>{{article.title}}</h2>
                    <div class="status_area">
                        <span class="date">{{pubDateText}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="viewer_area">
            <!-- article Viewer -->
            <div class="articleViewer" v-html="articleHtml"></div>
            <!-- //article Viewer -->

            <template v-if="article.files && article.files.length">
                <!-- [D] 첨부파일 영역 -->
                <div class="bx_include_file type2">
                    <span class="dsc">{{$t('SurveyEditorArticle_attachmentsNumber', {number: article.files.length})}}</span>
                    <ul class="lst_file">
                        <li v-for="file in article.files">
                            <button type="button" class="btn_download" @click="download(file)"><span class="sp" :class="getExtClass(file.title)"></span>{{file.title}}</button>
                        </li>
                    </ul>
                </div>
                <!-- // 첨부파일 영역 -->
            </template>
        </div>

    </div>
</template>

<script>
    import {mapFields} from "vuex-map-fields";
    import {NAMESPACE} from "@common/store/modules/survey/editor.js";
    import {toDateFormat} from "@/common/utils/date.js";
    import {toHtml} from '@unione/server.article-editor/src/article-converter';
    import {getExtensionClassName} from "@iamteacherpc/utils/file.js";
    import {download} from "@iamteacherpc/utils/file.js";

    export default {
        name: "SurveyEditorArticle",

        computed: {
            ...mapFields(NAMESPACE, [
                'form.article'
            ]),

            pubDateText() {
                return toDateFormat(this.article.pubDate);
            },

            articleHtml() {
                return toHtml(this.article.body);
            }
        },

        methods: {
            getExtClass(fileName) {
                return `ico_${getExtensionClassName(fileName)}`;
            },

            download(file) {
                download(file.url, file.title);
            }
        }
    }
</script>

<style scoped>

</style>
